import ExpensesIncome from '../../components/ExpensesIncome/ExpensesIncome';
import Background from '../Background/background';
import Container from '../../components/Container';

export default function CashFlowPage() {
  return (
    <Background>
      <Container>
        <ExpensesIncome />
      </Container>
    </Background>
  );
}
